/*!
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from '@alfresco/aca-shared';
import { AuthenticationService } from '@alfresco/adf-core';
import { SessionTimeoutService } from './components/skyplus/session-timeout/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(
    private appService: AppService,
    private authService: AuthenticationService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    this.appService.init();
  }

  ngOnInit(): void {
    // Start session monitoring when the user logs in
    this.authService.onLogin.subscribe(() => {
      this.sessionTimeoutService.initialize({
        timeoutMinutes: 30,
        warningMinutes: 5,
        checkIntervalSeconds: 30,
        extendOnActivity: true
      });
    });

    // Stop session monitoring when the user logs out
    this.authService.onLogout.subscribe(() => {
      this.sessionTimeoutService.stop();
    });

    // If already logged in when app loads (e.g. page refresh), start monitoring immediately
    if (this.authService.isLoggedIn()) {
      this.sessionTimeoutService.initialize({
        timeoutMinutes: 30,
        warningMinutes: 5,
        checkIntervalSeconds: 30,
        extendOnActivity: true
      });
    }
  }
}
